<template>
    <div class="d-flex flex-column w-100">
        <div class="w-100 d-flex flex-row">
            <b-form-file class="w-80" ref="upload"
                         :accept="accept"
                         v-model="fileList"
                         :multiple="multiple"
                         no-traverse
                         autofocus>
            </b-form-file>
            <mini-button variant="success" class="ml-1 w-20" data-toggle="tooltip" name="上传到服务器"
                         :disabled="loading"
                         @btnClick="submitUpload">
                <b-spinner small v-if="loading"></b-spinner>
                <i class="fa-solid fa-file-arrow-up" v-else></i>
            </mini-button>
        </div>
        <template v-if="multiple">
            <div class="w-100 d-flex flex-wrap m-1">
                <b-badge v-for="({name},index) of finalFileList" :key="index" :variant="badgeVariantIs(name)"
                         class="mr-1 mb-1" style="font-size:0.7rem;" @dblclick="removeFile(name)">
                    {{ name }}
                </b-badge>
            </div>
        </template>
    </div>

</template>

<script>
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import fileUpload from "@/components/common/inputs/mixin/file-upload";

export default {
    name: "FileUpload",
    components: {MiniButton},
    mixins: [fileUpload],
    props: {
        badgeVariantIs: {
            type: Function,
            default: () => {
                return null;
            }
        },
    }
}
</script>

<style scoped>
.w-100 >>> .b-form-file .custom-file-label {
    width: 100%;
}
</style>
